import React, { Component } from 'react';
import classnames from 'classnames';
import productUtils from '../../utils/productUtils';
import errorImages from '../../utils/errorImages';

export default class ProductImage extends Component {
    static defaultProps = {
        imageType: 'hero',
        width: 100,
        active: true,
        onImageLoad: () => {}
    };

    state = {
        has_error: false
    };

    handleLoad = (event) => {
        this.props.onImageLoad(event.target);
    };

    handleError = () => {
        this.setState({
            has_error: true
        });
    };

    render = () => {
        if (!this.props.product) {
            return null;
        }

        let { product, width, imageType } = this.props;
        let sku = product.format !== 'bookpack' ? product.sku : product.product_link;
        let url = productUtils.getImageUrl(sku, width, imageType);
        let bug = null;
        let tag = null;

        if (this.state.has_error && Object.keys(errorImages).includes(product.format)) {
            url = errorImages[product.format][imageType] || errorImages.playaway.cover;
        }

        if (product.format === 'bookpack') {
            bug = <img src="/images/bookpacks-bug.png" alt="" className="bookpacks-bug" />;
        }

        if (product.format === 'wonderbook') {
            bug = <img src="/images/WB_unit.png" alt="" srcSet="/images/WB_unit@2x.png" className="wonderbook-bug" />;
        }
        //product.sku !== 'WB000669' is the
        if (
            product.format === 'wonderbook' &&
            product.publisher === 'OrangeSky Publishing' &&
            product.sku !== 'WB000669'
        ) {
            tag = (
                <img
                    src="/images/creations_tag.png"
                    alt=""
                    srcSet="/images/creations_tag@2x.png"
                    className="wonderbook-creactions-tag"
                />
            );
        }
        let srcset = [
            `${productUtils.getImageUrl(sku, width, imageType)} 1x`,
            `${productUtils.getImageUrl(sku, width * 2, imageType)} 2x`
        ];

        return (
            <div
                className={classnames('product-image-wrapper', {
                    isWonderbookCreations: tag,
                    active: this.props.active
                })}
                style={{ maxWidth: width }}
            >
                <img
                    className={classnames(`product-image ${product.format}`, {
                        service: product.format && product.format.includes('service'),
                        warranty: product.format && product.format.includes('warranty')
                    })}
                    src={url}
                    onLoad={this.handleLoad}
                    onError={this.handleError}
                    alt={product.title}
                    srcSet={!this.state.has_error ? srcset.join(',') : null}
                />
                {!['inside'].includes(imageType) && bug}
                {['cover'].includes(imageType) && tag}
            </div>
        );
    };
}
